/* Shiny Leaf — floating widget placement (see sl-float.css)
   - html.sl-chat-open while the ElevenLabs chat panel is open, so it opens at full size
   - on product pages: html.sl-pdp + one of sl-f-top / sl-f-hide / sl-f-low, from the scroll position (chat bubble)
   - phones: places the accessibility button (#accessease-icon) full size and fully on screen, on the left edge:
     bottom-left by default, just above the sticky add-to-cart bar while it shows, and if that spot is covered by
     the buy box or other text/buttons it moves up to the nearest clear spot on the left */
(function () {
  if (window.__slFloatJs) return; window.__slFloatJs = true;
  var html = document.documentElement, tries = 0;

  function watch(host) {
    var sr = host.shadowRoot; if (!sr) return false;
    function sync() { html.classList.toggle('sl-chat-open', !!sr.querySelector('.rounded-sheet') && !sr.querySelector('.rounded-compact-sheet')); }
    new MutationObserver(sync).observe(sr, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    sync();
    return true;
  }
  (function find() {
    var host = document.querySelector('elevenlabs-convai');
    if (host && watch(host)) return;
    if (++tries < 40) setTimeout(find, 500);
  })();

  function pdp() {
    var forms = document.querySelectorAll('.slp-form');
    if (!forms.length) return;
    html.classList.add('sl-pdp');
    var state = '', ticking = false;
    function set(s) { if (s === state) return; if (state) html.classList.remove(state); html.classList.add(s); state = s; }
    function check() {
      ticking = false;
      if ((window.scrollY || window.pageYOffset) < 60) return set('sl-f-top');
      var vh = window.innerHeight, onScreen = false;
      for (var i = 0; i < forms.length; i++) {
        var r = forms[i].getBoundingClientRect();
        if (r.height && r.bottom > 0 && r.top < vh) { onScreen = true; break; }
      }
      set(onScreen ? 'sl-f-hide' : 'sl-f-low');
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pdp); else pdp();

  /* ---------- accessibility button placement (phones) ---------- */
  var SZ = 35, LEFT = 8, GAP = 10, PAD = 4;
  var BOX = '.slp-sub,.slp-plan,.slp-qty,.slp-qty-o,.slp-ironcmp,.slp-freq,.slp-btn,.slp-switch,.slp-stat,.slp-chip,.slp-sticky,.slp-assure li,.slp-trust span';
  var TAGS = { A: 1, BUTTON: 1, INPUT: 1, SELECT: 1, TEXTAREA: 1, LABEL: 1, SUMMARY: 1 }; /* photos and video frames are fine to sit on */
  var rg = document.createRange(), boxSet = new Set(), textMap = new Map(), near = new Set(), io = null, collected = false, recollectT = 0;
  /* things the button must not cover: every line of text, buttons/links/fields, and the buy-box boxes.
     Photos and video frames are fine to sit on. Text is measured line by line (not by its container), so a big
     card or section never blocks the whole edge. Only elements near the screen are measured (IntersectionObserver). */
  function skip(el, icon) { return el === icon || icon.contains(el) || !!el.closest('elevenlabs-convai,script,style,noscript,template,head'); }
  function collect(icon) {
    collected = true;
    if (io) io.disconnect();
    near.clear(); boxSet.clear(); textMap.clear();
    io = new IntersectionObserver(function (es) { for (var i = 0; i < es.length; i++) { if (es[i].isIntersecting) near.add(es[i].target); else near.delete(es[i].target); } queueA11y(); }, { rootMargin: '300px 0px' });
    var all = document.body.getElementsByTagName('*'), i, el;
    for (i = 0; i < all.length; i++) {
      el = all[i];
      if (!(TAGS[el.tagName] || el.getAttribute('role') === 'button' || el.matches(BOX))) continue;
      if (el.tagName === 'IMG' || skip(el, icon)) continue;
      boxSet.add(el); io.observe(el);
    }
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT), n, p, list;
    while ((n = w.nextNode())) {
      if (!n.nodeValue.trim()) continue;
      p = n.parentElement; if (!p || skip(p, icon)) continue;
      list = textMap.get(p); if (!list) { list = []; textMap.set(p, list); io.observe(p); }
      list.push(n);
    }
  }
  var a11yTop = null, a11yTick = false;
  function placeA11y() {
    a11yTick = false;
    var icon = document.getElementById('accessease-icon');
    if (!icon) return;
    if (window.innerWidth > 749) { if (a11yTop !== null) { icon.style.removeProperty('top'); icon.style.removeProperty('bottom'); a11yTop = null; } return; }
    if (!collected) collect(icon);
    var vh = window.innerHeight, x0 = LEFT - PAD, x1 = LEFT + SZ + PAD, blocks = [], r, k;
    function hit(r) { return r.width && r.height && r.right > x0 && r.left < x1 && r.bottom > 0 && r.top < vh; }
    function shown(el) { var cs = getComputedStyle(el); return cs.visibility !== 'hidden' && +cs.opacity >= 0.05; }
    near.forEach(function (el) {
      if (!el.isConnected) return;
      r = el.getBoundingClientRect(); if (!hit(r)) return;
      if (boxSet.has(el) && !(el.tagName === 'A' && r.height > 80) && shown(el)) blocks.push([r.top, r.bottom]); /* a whole clickable card: its text lines count instead */
      var list = textMap.get(el); if (!list) return;
      var ok = null;
      for (var j = 0; j < list.length; j++) {
        rg.selectNodeContents(list[j]);
        var rs = rg.getClientRects();
        for (k = 0; k < rs.length; k++) if (hit(rs[k])) { if (ok === null) ok = shown(el); if (!ok) return; blocks.push([rs[k].top, rs[k].bottom]); }
      }
    });
    var bottom = vh - SZ - 12;
    var sticky = document.querySelector('.slp-sticky.is-visible');
    if (sticky) { var sr = sticky.getBoundingClientRect(); if (sr.height && sr.top < vh) bottom = Math.min(bottom, sr.top - SZ - GAP); }
    bottom = Math.floor(bottom);
    function free(t) { for (var k = 0; k < blocks.length; k++) if (blocks[k][0] < t + SZ + PAD && blocks[k][1] > t - PAD) return false; return true; }
    var pick = null, t;
    for (t = bottom; t >= 8; t -= 2) { if (free(t)) { pick = t; break; } }
    icon.__slTight = pick === null; /* nothing clear on the whole left edge: stay bottom-left, above the sticky bar */
    if (pick === null) pick = bottom;
    if (pick !== a11yTop || icon.style.getPropertyValue('top') !== pick + 'px') {
      a11yTop = pick;
      /* set on the button itself, not on <html>, so the rest of the page is not restyled on every scroll frame */
      icon.style.setProperty('top', pick + 'px', 'important');
      icon.style.setProperty('bottom', 'auto', 'important');
    }
  }
  function queueA11y() { if (!a11yTick) { a11yTick = true; requestAnimationFrame(placeA11y); } }
  window.addEventListener('scroll', queueA11y, { passive: true });
  window.addEventListener('resize', queueA11y);
  document.addEventListener('click', function () { setTimeout(queueA11y, 60); }, true);
  var recollectSince = 0;
  function recollect() { var now = Date.now(); if (!recollectSince) recollectSince = now; if (now - recollectSince < 4000) clearTimeout(recollectT); else if (recollectT) return; recollectT = setTimeout(function () { recollectSince = 0; recollectT = 0; var ic = document.getElementById('accessease-icon'); if (ic && window.innerWidth <= 749) { collect(ic); queueA11y(); } }, 1200); }
  if (window.MutationObserver) new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) { var t = ms[i].target; if (t.closest && (t.closest('#accessease-icon') || t.closest('elevenlabs-convai'))) continue; if (ms[i].addedNodes.length || ms[i].type === 'characterData') { recollect(); return; } }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  if (window.MutationObserver) new MutationObserver(queueA11y).observe(html, { attributes: true, attributeFilter: ['class'] });
  var a11yTries = 0;
  (function waitIcon() { if (document.getElementById('accessease-icon')) { queueA11y(); setInterval(queueA11y, 700); /* layout settles late (fonts, apps, images): re-check */ } else if (++a11yTries < 40) setTimeout(waitIcon, 500); })();
})();
